import { render, staticRenderFns } from "./cardsList.vue?vue&type=template&id=d4c0ffd4"
import script from "./cardsList.vue?vue&type=script&lang=ts"
export * from "./cardsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports